import { graphql } from '@/gql';
import type { HomeServiceProviderInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createHomeServiceProvider = async (data: HomeServiceProviderInputType) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation CreateHomeServiceProvider($data: HomeServiceProviderInputType!) {
        createHomeServiceProvider(data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.createHomeServiceProvider;
};
